import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import CategorySelect from 'data-token-picker/components/CategorySelect';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Fragment, useEffect, useState } from 'react';
import { PropertyCategories } from 'data-token-picker/constants/Properties';
// @ts-expect-error TS7016, Drilldown has not yet been migrated.
import DrilldownSelect from './DrilldownSelect';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BrowserBody = ({
  onEdit,
  category,
  categories,
  field,
  fields,
  settingsLink
}) => {
  const [categoryLabel, setCategoryLabel] = useState();
  useEffect(() => {
    const findCurrent = categoryNode => {
      if (categoryNode.value === category) {
        setCategoryLabel(categoryNode.text);
        return true;
      }
      if (categoryNode.options) {
        categoryNode.options.some(findCurrent);
      }
      return false;
    };
    if (categories) {
      categories.some(findCurrent);
    }
  }, [category, categories]);
  const handleEditType = evt => {
    onEdit({
      category: evt.target.value
    });
  };
  const handleEditField = evt => {
    onEdit({
      category,
      fieldOption: evt.target.value
    });
  };
  let categoryHelpLink;
  if (category === PropertyCategories.SITE_SETTINGS && settingsLink) {
    categoryHelpLink = /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "data-token-picker.typeHelp.editOfficeSettingsLink",
      options: {
        href: settingsLink
      }
    });
  }
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(FormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "data-token-picker.typeLabel"
      }),
      help: categoryHelpLink,
      children: /*#__PURE__*/_jsx(CategorySelect, {
        onChange: handleEditType,
        options: categories,
        value: category
      })
    }), /*#__PURE__*/_jsx(FormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "data-token-picker.fieldLabel"
      }),
      children: /*#__PURE__*/_jsx(DrilldownSelect, {
        "data-test-id": "token-field-select",
        onChange: handleEditField,
        options: fields,
        value: field,
        placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "data-token-picker.fieldPlaceholder"
        }),
        rootBreadcrumb: categoryLabel
      }, category)
    })]
  });
};
BrowserBody.displayName = 'BrowserBody';
export default BrowserBody;